var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleSearchPressed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / navi / google_search_Pressed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-navi-/-google_search_Pressed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google_search"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6224,20.1684 C36.3834,20.1684 30.0594,20.1574 23.8204,20.1574 C23.8204,22.7474 23.8314,25.3794 23.8204,27.9694 L34.7354,27.9694 C34.3184,30.4494 32.8444,32.6834 30.7614,34.0854 C30.7594,34.0834 30.7564,34.0814 30.7544,34.0804 C29.4384,34.9684 27.9294,35.5354 26.3674,35.8144 C24.7944,36.0814 23.1784,36.1244 21.6164,35.8034 C20.0324,35.4814 18.5134,34.8174 17.1864,33.8874 C15.0694,32.4004 13.4644,30.2304 12.6294,27.7814 C12.6364,27.7754 12.6424,27.7714 12.6494,27.7664 C11.7934,25.2834 11.7934,22.5124 12.6494,20.0184 C13.2474,18.2714 14.2274,16.6524 15.5274,15.3424 C17.1434,13.6944 19.2304,12.5174 21.4774,12.0354 C23.4034,11.6184 25.4364,11.7034 27.3204,12.2704 C28.9254,12.7624 30.4024,13.6404 31.6114,14.7954 C32.8314,13.5754 34.0514,12.3554 35.2714,11.1354 C35.9134,10.4824 36.5874,9.8514 37.2084,9.1774 C35.3464,7.4544 33.1744,6.0844 30.7984,5.2074 C26.5184,3.6344 21.6914,3.6024 17.3904,5.0894 C12.5504,6.7454 8.4264,10.3654 6.1234,14.9564 C6.1204,14.9594 6.1184,14.9644 6.1164,14.9694 C6.1154,14.9724 6.1134,14.9744 6.1124,14.9774 C5.3164,16.5554 4.7414,18.2374 4.3904,19.9634 C3.5134,24.2854 4.1224,28.8954 6.1324,32.8204 C6.1264,32.8264 6.1194,32.8314 6.1134,32.8364 C7.4084,35.4034 9.2704,37.6934 11.5064,39.4714 C13.6364,41.1734 16.1074,42.4254 18.7404,43.1204 C22.0574,44.0084 25.5894,43.9864 28.9274,43.2274 C31.9424,42.5324 34.7964,41.1004 37.0744,38.9954 C37.0764,38.9974 37.0784,38.9984 37.0814,39.0004 C39.4894,36.7854 41.2124,33.8744 42.1214,30.7394 C43.1044,27.3154 43.2434,23.6674 42.6224,20.1684 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSearchPressed);
export default __webpack_public_path__ + "static/media/google_search_Pressed.f4a1aaa560005a74205b30b77d3254ef.svg";
export { ForwardRef as ReactComponent };